import { useCallback, useRef, useState } from "react";
import aa from "./adminApp.module.css";

const OPEN_THRESHOLD = 56;
const ACTION_WIDTH = 76;

/**
 * iOS-style swipe row: свайп влево открывает действия справа.
 */
export default function SwipeableRow({
  children,
  actions = [],
  className = "",
  disabled = false,
}) {
  const [offset, setOffset] = useState(0);
  const [open, setOpen] = useState(false);
  const startX = useRef(0);
  const startOffset = useRef(0);
  const dragging = useRef(false);

  const maxOffset = Math.min(actions.length * ACTION_WIDTH, ACTION_WIDTH * 3);

  const close = useCallback(() => {
    setOpen(false);
    setOffset(0);
  }, []);

  const onTouchStart = (e) => {
    if (disabled || !actions.length) return;
    dragging.current = true;
    startX.current = e.touches[0].clientX;
    startOffset.current = open ? maxOffset : 0;
  };

  const onTouchMove = (e) => {
    if (!dragging.current || disabled) return;
    const dx = startX.current - e.touches[0].clientX;
    const next = Math.max(0, Math.min(maxOffset, startOffset.current + dx));
    setOffset(next);
  };

  const onTouchEnd = () => {
    if (!dragging.current) return;
    dragging.current = false;
    if (offset >= OPEN_THRESHOLD) {
      setOpen(true);
      setOffset(maxOffset);
    } else {
      close();
    }
  };

  const runAction = (action) => {
    close();
    action.onClick?.();
  };

  if (!actions.length) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div
      className={`${aa.swipeRow} ${className}`.trim()}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      onTouchCancel={onTouchEnd}
    >
      <div className={aa.swipeRowActions} aria-hidden={!open && offset < 4}>
        {actions.map((action) => (
          <button
            key={action.id}
            type="button"
            className={`${aa.swipeRowAction} ${
              action.tone === "danger" ? aa.swipeRowActionDanger : ""
            }`}
            onClick={() => runAction(action)}
          >
            {action.label}
          </button>
        ))}
      </div>
      <div
        className={aa.swipeRowContent}
        style={{ transform: `translateX(-${offset}px)` }}
      >
        {children}
      </div>
    </div>
  );
}
